<template>
  <CConfirm ref="refCConfirm" :confirmDisabled="confirmDisabled">
    <h2 class="pos-prompt-title">请填写POS单号</h2>
    <div class="pos-prompt-form-item">
      <CLabel required>POS单号</CLabel>
      <CInput v-model="posNumber" placeholder="请输入内容">
        <template #suffix>
          <div class="pos-prompt-scan-icon" @click="throttledOnScanPos">
            <img src="@/assets/icons/scan-code.svg" alt="" />
          </div>
        </template>
      </CInput>
    </div>
    <div v-if="receiptNoVisible" class="pos-prompt-form-item">
      <CLabel>小票单号</CLabel>
      <CInput v-model="receiptNumber" placeholder="请输入内容">
        <template #suffix>
          <div class="pos-prompt-scan-icon" @click="throttledOnScanReceipt">
            <img src="@/assets/icons/scan-code.svg" alt="" />
          </div>
        </template>
      </CInput>
    </div>
  </CConfirm>
</template>

<script>
import CConfirm from "@/components/common/CConfirm.vue";
import CInput from "@/components/common/CInput.vue";
import CLabel from "@/components/common/CLabel.vue";
import { throttle } from "@/utils";
import { mapState } from "vuex";

export default {
  components: {
    CConfirm,
    CLabel,
    CInput,
  },
  data() {
    return {
      posNumber: "",
      receiptNumber: "",
    };
  },
  computed: {
    ...mapState(["brandInfo"]),
    receiptNoVisible() {
      return this.brandInfo.receiptNo?.enabled === true;
    },
    confirmDisabled() {
      return !this.posNumber;
    },
  },
  created() {
    this.throttledOnScanPos = throttle(this.onScanPos, 500);
    this.throttledOnScanReceipt = throttle(this.onScanReceipt, 500);
  },
  methods: {
    show() {
      return this.$refs.refCConfirm
        .show({
          onBeforeConfirm: () => {
            if (!/^[\da-z]+$/i.test(this.posNumber)) {
              this.$toast("只能输入字母或数字");
              return false;
            }
            return true;
          },
        })
        .then(() => {
          return {
            posNumber: this.posNumber,
            receiptNumber: this.receiptNumber || "",
          };
        });
    },
    hide() {
      this.$refs.refCConfirm.hide();
    },
    onScanPos() {
      wx.scanQRCode({
        needResult: 1,
        desc: "扫POS单号",
        scanType: ["qrCode", "barCode"],
        success: (res) => {
          console.log("onScanPos res", res);
          if (res.errMsg === "scanQRCode:ok") {
            console.log("onScanPos resultStr", res.resultStr);
            this.posNumber = res.resultStr;
          } else {
            console.log("onScanPos notOk", res.errMsg);
          }
        },
        fail: function (err) {
          console.error("onScanPos fail", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
        error: function (err) {
          console.error("onScanPos error", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
      });
    },
    onScanReceipt() {
      wx.scanQRCode({
        needResult: 1,
        desc: "扫小票单号",
        scanType: ["qrCode", "barCode"],
        success: (res) => {
          console.log("onScanPos res", res);
          if (res.errMsg === "scanQRCode:ok") {
            console.log("onScanPos resultStr", res.resultStr);
            this.receiptNumber = res.resultStr;
          } else {
            console.log("onScanPos notOk", res.errMsg);
          }
        },
        fail: function (err) {
          console.error("onScanPos fail", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
        error: function (err) {
          console.error("onScanPos error", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.pos-prompt {
  &-title {
    margin-bottom: 6/20rem;
    line-height: 20/20rem;
    text-align: center;
    font-weight: 400;
    font-size: 15/20rem;
    letter-spacing: 0;

    color: #000;
  }
  &-form-item {
    margin-bottom: 17/20rem;

    &:last-of-type {
      margin-bottom: 7/20rem;
    }

    .pos-prompt-scan-icon {
      width: 40/20rem;
      height: 38/20rem;
      padding: 8/20rem 9/20rem;
      img {
        width: 22/20rem;
        height: 22/20rem;
      }
    }
  }
}
</style>
